import React from "react";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import {IconButton, makeStyles, Tooltip} from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import DisplayAccountBalances from "./DisplayAccountBalances";
import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
    paper: {
        width: 10000
    },
}));

export default function NavBarAccountBalances() {
    const classes = useStyles();
    const popupState = usePopupState({
        variant: "popover",
        popupId: "setupFilterMenu",
    });
    return (
        <>
            <Tooltip disableFocusListener disableTouchListener title={"display account balances"}>
                <IconButton {...bindTrigger(popupState)}><AccountCircleIcon
                    style={{color: "white"}}/></IconButton>
            </Tooltip>
            <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}>
                <Box style={{width: 750}}>
                    <DisplayAccountBalances/>
                </Box>
            </Popover>
        </>
    );
}